export interface IGetIvcfRequest {
    ono: number;
    cadIvcfNo: number;
}
